import * as type from "../types";

export function getMarketMatchesRequested(filter) {
  return {
    type: type.GET_MARKET_MATCHES_REQUESTED,
    payload: filter,
  };
}
export function getMarketMatchesSucceeded(data) {
  return {
    type: type.GET_MARKET_MATCHES_SUCCEEDED,
    payload: data,
  };
}
export function getMarketMatchesFailed() {
  return {
    type: type.GET_MARKET_MATCHES_FAILED,
  };
}

export function getActiveOffersRequested(filter) {
  return {
    type: type.GET_ACTIVE_OFFERS_REQUESTED,
    payload: filter,
  };
}
export function getActiveOffersSucceeded(data) {
  return {
    type: type.GET_ACTIVE_OFFERS_SUCCEEDED,
    payload: data,
  };
}
export function getActiveOffersFailed() {
  return {
    type: type.GET_ACTIVE_OFFERS_FAILED,
  };
}
export function setMarketMatchesBuyerOrganization(organization) {
  return {
    type: type.SET_MARKET_MATCHES_BUYER_ORGANIZATION,
    payload: organization,
  };
}
export function setMarketMatchesSellerOrganization(organization) {
  return {
    type: type.SET_MARKET_MATCHES_SELLER_ORGANIZATION,
    payload: organization,
  };
}
export function getSystemParticipantMatchesRequested(filter) {
  return {
    type: type.GET_SYSTEM_PARTICIPANT_MATCHES_REQUESTED,
    payload: filter,
  };
}
export function getSystemParticipantMatchesSucceeded(data) {
  return {
    type: type.GET_SYSTEM_PARTICIPANT_MATCHES_SUCCEEDED,
    payload: data,
  };
}
export function getSystemParticipantMatchesFailed() {
  return {
    type: type.GET_SYSTEM_PARTICIPANT_MATCHES_FAILED,
  };
}

export function getSystemParticipantOffersRequested(filter) {
  return {
    type: type.GET_SYSTEM_PARTICIPANT_OFFERS_REQUESTED,
    payload: filter,
  };
}
export function getSystemParticipantOffersSucceeded(data) {
  return {
    type: type.GET_SYSTEM_PARTICIPANT_OFFERS_SUCCEEDED,
    payload: data,
  };
}
export function getSystemParticipantOffersFailed(data) {
  return {
    type: type.GET_SYSTEM_PARTICIPANT_OFFERS_FAILED,
  };
}
export function sendCancalledMatchesRequested(filter) {
  return {
    type: type.SEND_MARKET_CANCELLED_MATCHES_REQUESTED,
    payload: filter,
  };
}
export function sendCancalledMatchesSucceeded(data) {
  return {
    type: type.SEND_MARKET_CANCELLED_MATCHES_SUCCEEDED,
    payload: data,
  };
}
export function sendCancalledMatchesFailed(data) {
  return {
    type: type.SEND_MARKET_CANCELLED_MATCHES_FAILED,
    payload: data,
  };
}

export function resetInitialState() {
  return {
    type: type.RESET_INITIAL_STATE,
  };
}
